import $ from 'jquery';
import { initZoomLock } from './components/zoom-lock';
import { initSolutions } from './components/solutions';
import { initStories } from './components/stories';
import { initPosts } from './components/posts';
import { initScrollAnimations } from './components/scroll-animations';
import { initTestimonials } from './components/testimonials';
import { initVideoVisibility } from './components/video-visibility';
import {
    AUTOPLAY_SELECTOR,
    READY_GATE_ATTRIBUTE,
    isReadyGateClosed,
    playVideo,
} from './components/video-playback';

const READY_STATE_ENOUGH_DATA = 4;
const READY_GATE_TIMEOUT = 10000;

function applyPlaybackRate(video) {
    const rate = parseFloat(video.dataset.playbackRate);

    if (!rate) {
        return;
    }

    video.defaultPlaybackRate = rate;
    video.playbackRate = rate;
}

function isInViewport(video) {
    const rect = video.getBoundingClientRect();

    return rect.bottom > 0 && rect.top < window.innerHeight;
}

function startPlayback(video) {
    playVideo(video);

    const onInteract = () => {
        playVideo(video);
        document.removeEventListener('touchstart', onInteract);
        document.removeEventListener('scroll', onInteract);
    };

    document.addEventListener('touchstart', onInteract, { once: true, passive: true });
    document.addEventListener('scroll', onInteract, { once: true, passive: true });
}

function openReadyGate(video) {
    if (!isReadyGateClosed(video)) {
        return;
    }

    video.removeAttribute(READY_GATE_ATTRIBUTE);

    if (!isInViewport(video)) {
        return;
    }

    startPlayback(video);
}

function ensureVideoPlay(video) {
    if (!video) {
        return;
    }

    applyPlaybackRate(video);

    if (!isReadyGateClosed(video)) {
        startPlayback(video);

        return;
    }

    if (video.readyState >= READY_STATE_ENOUGH_DATA) {
        openReadyGate(video);

        return;
    }

    video.addEventListener('canplaythrough', () => openReadyGate(video), { once: true });
    video.addEventListener('error', () => openReadyGate(video), { once: true });
    window.setTimeout(() => openReadyGate(video), READY_GATE_TIMEOUT);
}

$(() => {
    initZoomLock();
    initSolutions();
    initStories();
    initPosts();
    initScrollAnimations();
    initTestimonials();
    document.querySelectorAll(AUTOPLAY_SELECTOR).forEach(ensureVideoPlay);
    initVideoVisibility();
});
